import script from "./NewsShoutPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsShoutPanel.vue?vue&type=script&setup=true&lang=ts"

import "./NewsShoutPanel.vue?vue&type=style&index=0&id=74c547d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c547d6"]])

export default __exports__